import type { LucideIcon, LucideProps } from 'lucide-react'
import { forwardRef } from 'react'

export const HamburgerThinIcon: LucideIcon = forwardRef<SVGSVGElement, LucideProps>(({ size = 20, ...props }, ref) => {
  return (
    <svg
      ref={ref}
      width={size}
      height={(+size * 8) / 20}
      viewBox="0 0 20 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 0.800156C0 0.35824 0.344393 0 0.769229 0H19.2307C19.6556 0 19.9999 0.35824 19.9999 0.800156C19.9999 1.2421 19.6556 1.60031 19.2307 1.60031H0.769229C0.344393 1.60031 0 1.2421 0 0.800156Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.10156 7.19859C4.10156 6.75665 4.44593 6.39844 4.87079 6.39844H19.2297C19.6546 6.39844 19.9989 6.75665 19.9989 7.19859C19.9989 7.64054 19.6546 7.99875 19.2297 7.99875H4.87079C4.44593 7.99875 4.10156 7.64054 4.10156 7.19859Z"
        fill="currentColor"
      />
    </svg>
  )
})

HamburgerThinIcon.displayName = 'HamburgerThinIcon'
